import { CheckIcon } from '@heroicons/react/outline';
import React from 'react';

interface IProps {
  product: any;
  handleChange: any;
}

const ActiveSubscription: React.FC<IProps> = ({ product, handleChange }) => {
  return (
    <div className="max-w-lg mx-auto mt-10">
      <div className="flex border border-gray-200 rounded-lg shadow-sm divide-x divide-gray-200">
        <div className="p-6">
          <h2 className="text-lg leading-6 font-medium text-gray-900">
            Subscription
          </h2>
          <p className="mt-4 text-sm text-gray-500">Active</p>
          {/* <p className="mt-8">
            <span className="text-4xl font-extrabold text-gray-900">
              ${product.amount / 100}
            </span>{' '}
            <span className="text-base font-medium text-gray-500">/mo</span>
          </p> */}
          <div className="mt-8 block w-full bg-gray-100 border border-gray-300 rounded-md py-2 text-sm font-semibold text-gray-400 text-center">
            Current Plan
          </div>
          <div className="pt-5 flex items-center justify-center">
            <button
              className="text-sm font-medium text-primary hover:text-primary-light"
              onClick={handleChange}
            >
              Change your subscription
            </button>
          </div>
        </div>
        {/* <div className="pt-6 pb-8 px-6">
          <h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">
            What's included
          </h3>
          <ul className="mt-6 space-y-4">
            {product.features.map((feature: string) => (
              <li key={feature} className="flex space-x-3">
                <CheckIcon
                  className="flex-shrink-0 h-5 w-5 text-green-500"
                  aria-hidden="true"
                />
                <span className="text-xs text-gray-500">{feature}</span>
              </li>
            ))}
          </ul>
        </div> */}
      </div>
    </div>
  );
};

export default ActiveSubscription;
